import React, { Component } from "react";
import FooterPanel from "../common/FooterPanel";
import MenuBar from "../common/MenuPanel";
import ministriesData from "../../source/ministries.json"; // Ensure this path is correct

class MinistriesPage extends Component {
  renderTile = (args) => {
    return (
      <div className="feature-item p-3" style={{ textAlign: "justify" }}>
        {" "}
        {/* Justified text */}
        <p className="h4 mb-3">{args.name}</p>
        <img
          className="img-fluid"
          src={args.image}
          alt={args.name}
          style={{ width: "100%", height: "200px", objectFit: "cover" }} // Ensures same image size
        />
        <p className="mb-3">{args.desc}</p>
        <a href={args.url} className="btn btn-outline-primary">
          Read More <i className="bi bi-arrow-right-circle" />
        </a>
      </div>
    );
  };
  render() {
    return (
      <React.Fragment>
        <div className="container position-relative p-0">
          <MenuBar />
        </div>

        <div>
          {/* Header Start */}
          <div
            className="banner-image "
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/images/international_banner-image-1.png)`,
            }}
          >
            <div className="container-fluid ">
              <div className="banner-heading text-center wow fadeInDown">
                <h1 className="text-white">Our Ministires</h1>
              </div>
            </div>
          </div>
          {/* Header End */}
        </div>
        {/* Navbar & Hero End */}

        {/* Ministry Tiles Section */}
        <div className="container-fluid feature bg-light py-4">
          <div className="row g-4">
            {ministriesData.map((ministry, index) => (
              <div
                key={index}
                className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp"
                data-wow-delay={`${0.2 * (index + 1)}s`}
              >
                {this.renderTile(ministry)}
              </div>
            ))}
          </div>
        </div>

        <FooterPanel />
      </React.Fragment>
    );
  }
}

export default MinistriesPage;
